import { config } from '@/config';
import { getAdyenLocale } from '@/helpers/adyen';
import { getLang } from '@/locale';

const locale = getAdyenLocale(getLang());
const environment = config.env === 'production' || config.env === 'staging' ? 'LIVE' : 'TEST';
const clientKey = config.adyenClientKey;
const giftcardAdyenClientKey = config.giftcardAdyenClientKey;

export type AdyenCheckoutConfigutation = typeof checkoutConfig;

export const checkoutConfig = (amount: number, isGiftcardCheckout?: boolean) => ({
  paymentMethodsConfiguration: {
    card: {
      hasHolderName: true,
      holderNameRequired: true,
      name: 'Credit or debit card',
      amount: { value: amount, currency: 'SEK' },
    },
  },
  locale,
  environment,
  clientKey: isGiftcardCheckout ? giftcardAdyenClientKey : clientKey,
});

export const threeDSConfig = {
  locale,
  environment,
  clientKey,
};
